import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funcionalidades',
  templateUrl: './funcionalidades.component.html',
  styleUrls: ['./funcionalidades.component.scss']
})
export class FuncionalidadesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
